import React from 'react';
import { Icon } from '@chakra-ui/icons';

export const WebIcon = ({ color = 'white' }: { color?: string }) => {
	return (
		<Icon
			width="auto"
			height="7px"
			viewBox="0 0 23 7"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M4.28845 6.23164V0.535645H5.76045V6.23164H4.28845ZM0.512451 6.23164V0.535645H1.98445V6.23164H0.512451ZM0.952451 3.92764V2.75164H5.17645V3.92764H0.952451Z"
				fill={color}
			/>
			<path
				d="M8.14589 6.23164V1.75164H6.44989V0.535645H11.3619V1.75164H9.66589V6.23164H8.14589Z"
				fill={color}
			/>
			<path
				d="M12.0715 6.23164V0.535645H13.2475L15.1995 4.99164H14.7035L16.6475 0.535645H17.8155V6.23164H16.5035L16.4955 2.80764L16.7995 2.89564L15.4155 6.23164H14.4635L13.0555 2.89564L13.3755 2.80764V6.23164H12.0715Z"
				fill={color}
			/>
			<path
				d="M18.94 6.23164V0.535645H20.444V5.01564H22.852V6.23164H18.94Z"
				fill={color}
			/>
		</Icon>
	);
};
